import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=96a23092&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"
import style0 from "./theme.vue?vue&type=style&index=0&id=96a23092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a23092",
  null
  
)

export default component.exports